import { isSavedAnalysis } from '@modules/analysis/helpers';
import { useAnalysisStore } from '@modules/analysis/store/analysisStore';
import { AnalysisActionType } from '@modules/analysis/types';
import { useIsArtefactEditable } from '@modules/common/hooks';
import { useMemo } from 'react';
import { shallow } from 'zustand/shallow';
export const useGetAnalysisSaveActionType = () => {
  const { id, editToken, status } = useAnalysisStore(
    ({ id, editToken, status }) => ({
      id,
      editToken,
      status,
    }),
    shallow,
  );

  const isEditable = useIsArtefactEditable({
    editToken,
    status,
  });

  const actionType = useMemo(() => {
    if (!isSavedAnalysis(id)) {
      return AnalysisActionType.SAVE;
    }

    if (isEditable) {
      return AnalysisActionType.SAVE_UPDATE;
    }

    return AnalysisActionType.SAVE_AS;
  }, [id, isEditable]);

  return actionType;
};
